import React from "react";
import { Box, Typography, Button, Container, Stack, Divider, Chip, Paper } from "@mui/material";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import workdesk from "../assets/images/workdesk.webp";

const Banner = () => {
  return (
    <Box
      component="section"
      sx={{
        position: "relative",
        overflow: "hidden",
        backgroundImage: `radial-gradient(circle at 20% 20%, rgba(20,184,166,0.25), transparent 55%), radial-gradient(circle at 80% 0%, rgba(249,115,22,0.35), transparent 60%), url(${workdesk})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        color: "#f8fafc",
        minHeight: { xs: "90vh", md: "calc(100vh - 120px)" },
        display: "flex",
        alignItems: "center",
        py: { xs: 8, md: 12 },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background: "rgba(2, 6, 23, 0.78)",
          backdropFilter: "blur(6px)",
        }}
      />
      <Container sx={{ position: "relative", zIndex: 2 }}>
        <Stack spacing={4} maxWidth={880}>
          <Chip
            label="Product studio · Cloud · Cybersecurity"
            sx={{
              alignSelf: "flex-start",
              fontWeight: 600,
              letterSpacing: "0.05em",
              backgroundColor: "rgba(20,184,166,0.25)",
              color: "#5eead4",
              borderRadius: 2,
            }}
          />
          <Typography
            variant="h2"
            sx={{
              fontWeight: 700,
              lineHeight: 1.1,
              fontSize: { xs: "2.6rem", md: "3.8rem" },
            }}
          >
            Build experiences your customers can{" "}
            <Box component="span" sx={{ color: "#5eead4" }}>
              trust
            </Box>{" "}
            and your teams can{" "}
            <Box component="span" sx={{ color: "#f97316" }}>
              scale
            </Box>
            .
          </Typography>
          <Typography
            variant="body1"
            sx={{
              maxWidth: 640,
              fontSize: { xs: "1.05rem", md: "1.2rem" },
              color: "rgba(248,250,252,0.92)",
              lineHeight: 1.7,
            }}
          >
            MC3 Smart Tech blends strategy, design, full-stack engineering, and managed security into one accountable
            team. We accelerate transformation for fintech, health, mobility, and public sector innovators across the
            globe.
          </Typography>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={2.5}>
            <Button
              variant="contained"
              size="large"
              endIcon={<ArrowForwardRoundedIcon />}
              href="/contact-us"
              sx={{
                px: 4,
                py: 1.3,
                background: "linear-gradient(120deg, #f97316, #fbbf24)",
                color: "#111",
                "&:hover": {
                  background: "linear-gradient(120deg, #ea580c, #f59e0b)",
                },
              }}
            >
              Design my roadmap
            </Button>
            <Button
              variant="outlined"
              size="large"
              color="secondary"
              startIcon={<PlayArrowRoundedIcon />}
              href="#journey"
              sx={{
                borderColor: "rgba(248,250,252,0.6)",
                color: "#f8fafc",
                "&:hover": { borderColor: "#5eead4", color: "#5eead4" },
              }}
            >
              See our story
            </Button>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};

export default Banner;
